import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6513ebe4&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=6513ebe4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6513ebe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6513ebe4')) {
      api.createRecord('6513ebe4', component.options)
    } else {
      api.reload('6513ebe4', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=6513ebe4&scoped=true", function () {
      api.rerender('6513ebe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/query/Header.vue"
export default component.exports